import styled from "styled-components";

export const ItemWrapper = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    column-gap: 20px;
    font-size: 12px;
    border-bottom: 1px solid #E0E0E0;

`
export const ItemHeaderWithTabs = styled.div`
    padding: 20px 20px 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    column-gap: 20px;
    font-size: 12px;
`
export const Column = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`
export const HeaderColumn = styled(Column)`
    font-weight: bold;
`
export const ColumnItem = styled.div`
    padding-top: 5px;
    height: 12px;
`
export const ColumnItemLinksTo = styled(ColumnItem)`
    padding-bottom: 10px;
`
export const IconColumnItem = styled.div`

`